
import { IAuthProvider } from "./IAuthProvider";
import { AppDispatch } from "../../configureStore";

export class KeycloakAuthProvider implements IAuthProvider {

    async login(): Promise<void> {
        console.log("Keycloak login() -> redirect");
        const baseUrl = (window._env_.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_BASE_URL) ?? "";
        const returnUrl = encodeURIComponent(window.location.href);
        const urlWithoutSlash = baseUrl.replace(/\/+$/, "");
        window.location.href = `${urlWithoutSlash}/KeycloakAuth/keycloak-login?returnUrl=${returnUrl}`;
    }

    async logout(keyCloakIdToken?: string | null): Promise<void> {
        console.log("Keycloak logout()");
        
        sessionStorage.clear();
        localStorage.clear();

        const rawKeycloakUrl = (window._env_.REACT_APP_KEYCLOAK_URL || process.env.REACT_APP_KEYCLOAK_URL) ?? "";
        const keycloakUrl = rawKeycloakUrl ? rawKeycloakUrl.replace(/\/+$/, "") : ""; // Remove trailing slash if exists
        const realm = (window._env_.REACT_APP_KEYCLOAK_REALM || process.env.REACT_APP_KEYCLOAK_REALM) ?? "";
        const clientId = (window._env_.REACT_APP_KEYCLOAK_CLIENT_ID || process.env.REACT_APP_KEYCLOAK_CLIENT_ID) ?? "";
        const redirectUri = encodeURIComponent(window.location.origin);

        let logoutUrl = `${keycloakUrl}/realms/${realm}/protocol/openid-connect/logout`;

        if (keyCloakIdToken) {
            logoutUrl += `?id_token_hint=${keyCloakIdToken}&post_logout_redirect_uri=${redirectUri}&client_id=${clientId}`;
        }

        window.location.href = logoutUrl;
    }

    getToken(): string | null {
        return sessionStorage.getItem("accessToken");
    }

    handleRedirect(dispatch: AppDispatch, externalSignIn: (token: string, useCache?: boolean) => any): void {

        console.log("Keycloak redirect handled, user authenticated");
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('code'); // Or however your backend passes it

        if (token) {
            // Clean up URL
            window.history.replaceState({}, document.title, window.location.pathname);
            
            sessionStorage.setItem("accessToken", token);
            dispatch(externalSignIn(token,true));
        }
    }

    async refreshToken(): Promise<string | null> {
        const baseUrl = (window._env_.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_BASE_URL) ?? "";
        const urlWithoutSlash = baseUrl.replace(/\/+$/, "");

        try {
            const response = await fetch(`${urlWithoutSlash}/KeycloakAuth/refresh-token`, {
                method: 'POST',
                credentials: 'include' // Include cookies if using cookie-based session
            });

            if (response.ok) {
                const data = await response.json();
                sessionStorage.setItem("accessToken", data.token);
                return data.token;
            }
            return null;
        } catch (error) {
            console.error("Token refresh failed:", error);
            return null;
        }
    }


}
